module.exports = __webpack_public_path__ + "img/train-icon-white.92e4befc.svg";